module Meevo.Components.Common {
    "use strict";

    export class AddressFieldsService implements IAddressFieldsService {
        private stateCache: { [country: string]: Array<{ state: string }> } = {};

        constructor(
            private postalCodeService: IPostalCodeService,
            private appSettings: IAppSettings,
            private $q: angular.IQService
        ) {
        }

        getStates(country: string): angular.IPromise<Array<{ state: string }>> {
            if (!country || country === 'OTHER') {
                return this.$q.resolve([]);
            }
            if (this.stateCache[country]) {
                return this.$q.resolve(this.stateCache[country]);
            }
            return this.postalCodeService.getStates({ country })
                .then((response: any) => {
                    const list = (response && response.data) ? response.data : [];
                    this.stateCache[country] = list;
                    return list;
                });
        }

        getZipCodeRegEx(country: string): RegExp {
            const entry = this.appSettings.APP_COUNTRIES && this.appSettings.APP_COUNTRIES[country];
            if (!entry || !entry.PostalCodeRegEx) return null;
            return new RegExp(entry.PostalCodeRegEx);
        }

        getDefaultCountryForProvider(merchantProviderId: number): string {
            if (Meevo.Model.MerchantAccountProvider.isMeevoPay(merchantProviderId)) return 'US';
            if (Meevo.Model.MerchantAccountProvider.isMeevoPayCanada(merchantProviderId)) return 'CA';
            return null;
        }

        handleCountryChange(
            addressData: any,
            newCountry: string,
            previousCountry?: string
        ): angular.IPromise<Array<{ state: string }>> {
            if (!addressData) return this.$q.resolve([]);
            if (previousCountry && previousCountry !== newCountry) {
                addressData.state = null;
                addressData.city = null;
                addressData.zipCode = null;
            }
            addressData.country = newCountry;
            return this.getStates(newCountry);
        }

        static factory(): Function {
            const svc = (
                postalCodeService: IPostalCodeService,
                appSettings: IAppSettings,
                $q: angular.IQService
            ) => new AddressFieldsService(postalCodeService, appSettings, $q);
            svc.$inject = ['meevo.components.common.PostalCodeService', 'meevo.AppSettings', '$q'];
            return svc;
        }
    }

    angular.module('meevo.components.common')
        .factory('meevo.components.common.AddressFieldsService', AddressFieldsService.factory());
}
